var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDiameterLengthHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37695 20.4838H19.997",
    stroke: "#0076ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1975 20.4337L2.0375 16.2737C1.9875 16.2237 1.9875 16.1437 2.0375 16.0937L14.5775 3.55374C14.6275 3.50374 14.7075 3.50374 14.7575 3.55374L18.9375 7.73374C18.9875 7.78374 18.9875 7.86374 18.9375 7.91374L6.4175 20.4337C6.3575 20.4937 6.2575 20.4937 6.1975 20.4337Z",
    stroke: "#0076ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83789 13.9838L6.28789 15.4438",
    stroke: "#0076ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46777 10.3539L9.92777 11.8039",
    stroke: "#0076ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1074 6.71375L13.5574 8.17374",
    stroke: "#0076ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDiameterLengthHover);
export default __webpack_public_path__ + "static/media/ico-diameter-length-hover.a7327e19dde7bea73d8ae1b82ef744df.svg";
export { ForwardRef as ReactComponent };